import { BMEventsType } from '../types';
export const isPageLoadMetricData = data => {
  return data.type === BMEventsType.PAGE_LOAD;
};
export const isPageSegmentLoadMetricData = data => {
  return data.type === BMEventsType.PAGE_SEGMENT_LOAD;
};
export const isPageLoadConfig = data => {
  return data.type === BMEventsType.PAGE_LOAD;
};
export const isPageSegmentLoadConfig = data => {
  return data.type === BMEventsType.PAGE_SEGMENT_LOAD;
};
export const isInteractionConfig = data => {
  return data.type === BMEventsType.INLINE_RESULT;
};
export const isCustomConfig = data => {
  return data.type === BMEventsType.CUSTOM;
};